<div class="header">
    <div class="logo-container">
        <a href="#"><img src="assets/icon/footer-logo-img.webp" alt="Virinchi Engineering Logo"></a>
    </div>
</div>

<div class="content">
    <!-- Section 1 -->
    <div class="section">
        <h2>Virinchi Engineering Pvt Ltd</h2>
        <p class="address">
            10th Floor (Back Side),<br>
            Techno One (Sandhya Techno-1),<br>
            Khajaguda, Hyderabad, Telangana &ndash; 500081.
        </p>

        <h2 class="follow-title">Follow us on</h2>
        <div class="social-icons">
            <a href="#" aria-label="Facebook">
                <img src="assets/icon/Facebook.svg" alt="Facebook">
            </a>

            <a href="#" aria-label="Instagram">
                <img src="assets/icon/Instagram.svg" alt="Instagram">
            </a>

            <a href="#" aria-label="Twitter">
                <img src="assets/icon/Twitter.svg" alt="Twitter">
            </a>
        </div>

    </div>

    <!-- Section 2 -->
    <div class="section">
        <h2>Working Hours</h2>
        <p>
            We work 5 days a week, every day excluding major<br />
            holidays. Contact us if you have an emergency, with our Hotline and Contact form.
        </p>

        <ul class="working-list">
            <li>Monday - Friday: 09:30 - 18:30</li>
        </ul>
    </div>

    <!-- Section 3 -->
    <div class="section">
        <h2>Services</h2>
        <ul class="service-list">
            <li>PLANNING</li>
            <li>ENGINEERING</li>
            <li>CONSTRUCTION MANAGEMENT</li>
            <li>PROJECT MANAGEMENT & CONTROL</li>
            <li>PROCUREMENT</li>
        </ul>
    </div>
</div>

<div class="footer">
    Copyright 2024 | All Rights Reserved
</div>